const canvasPluginExtend = {
    addImage(imageSrc) {
        this.getActiveCanvasStage().cf_Image.add(imageSrc);
    },
    getKonva() {
        return window.Konva;
    },
    resetActiveCanvas() {
        canvasTool.getActiveCanvasWrapper().querySelector('.cf_state-reset').click();
    },
    getActiveCanvasStage() {
        let stageId = canvasTool.getActiveCanvasWrapper().querySelector('canvas').dataset.stage;

        return canvasPluginExtend.getKonva().ids[stageId];
    },
    clearTransformers() {
        canvasPluginExtend.getActiveCanvasStage().cfTransforming.clearTransforms();
    }
};
const canvasTool = {
    init() {
        document.addEventListener('app_canvas_plugin_inited', this.listeners);
        document.addEventListener('app_canvas_plugin_image_layer_added', this.processBackgroundImages);

        return this;
    },
    listeners() {
        document.querySelectorAll('.canvas__tab-color_rgb').forEach(item => {
            item.addEventListener('change', canvasTool.changeColour)
        })
        document.querySelectorAll('.tabs__content__item__tools__reset').forEach(item => {
            item.addEventListener('click', canvasPluginExtend.resetActiveCanvas)
        })
        document.querySelectorAll('.canvas__tab-add_text').forEach(item => {
            item.addEventListener('click', canvasTool.addText)
        })
        document.querySelectorAll('.canvas__tab-font_size .list .option').forEach(item => {
            item.addEventListener('click', canvasTool.changeFontSize)
        })
        document.querySelectorAll('.canvas__tab-font_family .list .option').forEach(item => {
            item.addEventListener('click', canvasTool.changeFont)
        })

        canvasTool.default();
    },
    processBackgroundImages(e){
        let stage = e.detail;

        if(!stage.isProcessedBackgroundImage){
            let image = stage.getLayers()[0].find('Image')[0];
            image.name('background');
            image.visible(false);

            stage.draw();
            stage.connector.window.updateTexture(stage);

            stage.isProcessedBackgroundImage = true;
        }
    },
    default() {
        document.querySelectorAll('.cf_text-font_input').forEach(item => {
            item.value = "'Brave-Eightyone-Regular'";
        })    
    },
    changeColour(e) {
        let colorInput = canvasTool.getActiveCanvasWrapper().querySelector('.cf_text-color_input');
        colorInput.value = e.target.value;
        colorInput.dispatchEvent(new Event('change'));
    },
    changeFontSize(e) {
        let canvasText = canvasTool.getActiveCanvasWrapper().querySelector('.cf_text-size');
        canvasText.value = e.target.dataset.value;
        canvasText.dispatchEvent(new Event('input'));
    },
    changeFont(e) {
        let canvasText = canvasTool.getActiveCanvasWrapper().querySelector('.cf_text-font_input');
        canvasText.value = e.target.dataset.value;
        canvasText.dispatchEvent(new Event('change'));
    },
    addText() {
        canvasTool.getActiveCanvasWrapper().querySelector('.cf_text .cf_text-add').click();
    },
    getActiveCanvasWrapper() {
        return document.querySelector('.canvas__tab:not(.hidden)');
    },
    addImage(el) {
        canvasPluginExtend.addImage(blob, 'fromGallery', imageSrc);
    },
    dataURLToBase64(dataURL) {
        return dataURL.split(';base64,')[1];
    },
    zipAppendWithCanvasTab(tabId, zip, folderName) {
        let canvas = document.querySelector(`#${tabId} canvas`);
        if (canvas) {
            let stage = Konva.ids[canvas.dataset.stage];
            let folder = zip.folder(folderName);

            //adding source images
            let sourcesFolder = folder.folder('sources');
            for (const image of stage.getLayers()[0].find('Image')) {
                if(image.name() !== 'background'){
                    sourcesFolder.file(`${image.name()}.png`, canvasTool.dataURLToBase64(image.attrs.image.src), { base64: true });
                }
            }

            //adding canvas screenshot
            let canvasImage = '';

            let background = stage.getLayers()[0].find('.background');
            background.moveToBottom();
            background.visible(true);
            stage.draw();

            canvasImage = canvasTool.dataURLToBase64(canvas.toDataURL());

            background.visible(false);
            stage.draw();
            stage.connector.window.updateTexture(stage);

            folder.file('canvas.png', canvasImage, { base64: true });
        }
    },
    generateZipContent() {
        var zip = new JSZip();

        canvasTool.zipAppendWithCanvasTab('canvas_walls', zip, 'walls');
        canvasTool.zipAppendWithCanvasTab('canvas_surface', zip, 'surface');

        return zip.generateAsync({ type: "base64" });
    }
}.init();